import { useContext } from 'react';
import { InteractionContext } from '@/state/InteractionContextInstance';
import type { InteractionContextValue } from '@/state/InteractionContextInstance';

export function useInteraction(): InteractionContextValue {
  const ctx = useContext(InteractionContext);
  if (!ctx) throw new Error('useInteraction must be used within InteractionProvider');
  return ctx;
}
